import React from 'react';
import { graphql } from 'react-relay';
import { Query } from '../../index';
import { populateChildren } from '../toolbox';

export const QDocumentInstanceQuery = graphql`
  query QDocumentInstanceQuery($documentId: ID!, $externalId: ID!) {
    documentInstance(documentId: $documentId, externalId: $externalId) {
      id
      documentId
      externalId
      name
      teamId
      variables
      padding {
        top
        right
        bottom
        left
      }
      orientation
      renderingEngineVersion
      pages {
        breakPage
        padding {
          top
          bottom
          left
          right
        }
        rules {
          action
          conditions {
            condition
            variable
            value
            operator
          }
        }
        widgets {
          widgets {
            widgetId
            rootWidgetId
            type
            rules {
              action
              conditions {
                condition
                variable
                value
                operator
              }
            }
          }
          breakPage
          rulesBreakPage {
            action
            conditions {
              condition
              variable
              value
              operator
            }
          }
          padding {
            top
            right
            bottom
            left
          }
        }
        header {
          widgets {
            widgetId
            rootWidgetId
            type
            rules {
              action
              conditions {
                condition
                variable
                value
                operator
              }
            }
          }
          padding {
            top
            right
            bottom
            left
          }
        }
        footer {
          widgets {
            widgetId
            rootWidgetId
            type
            rules {
              action
              conditions {
                condition
                variable
                value
                operator
              }
            }
          }
          padding {
            top
            right
            bottom
            left
          }
        }
      }
    }
  }
`;

const QDocumentInstance = ({
  args,
  children,
  childDataProp
}) => (
  <Query
    args={args}
    query={QDocumentInstanceQuery}
  >
    {populateChildren()(children, childDataProp)}
  </Query>
);

export default QDocumentInstance;
